<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>

                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="model.periodo"
                        :max-date="data.form.dataAtual"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                    />
                </rkm-col>

                <rkm-col cols="6" >
                    <rkm-form-input-autocomplete
                        :searchFields="localPaciente.autocompleteFieldsPaciente.paciente"
                        :repository="repositories.paciente"
                        v-model="paciente"
                        :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                        label="Paciente"
                        uppercase
                        @select="setListagem()"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="flex-nowrap">

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        label="Data de nascimento"
                        v-model="model.dataNascimento"
                        :max-date="data.form.dataAtual"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Prontuário"
                        v-model="model.prontuario"
                        number
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="agendamentoExame"
                        label="Exame"
                        show-default-option
                        text-field="nome"
                        v-model="model.exameId"
                        value-field="id"
                        @change="setListagem()"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="Número do agendamento"
                        v-model="model.agendamentoNumero"
                        number
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-row class="mt-3" v-if="itemsNotSave">
            <rkm-col>

                <rkm-button
                    @click="selecionarTodos()"
                    color="primary"
                    class="mb-2"
                >
                    <template v-if="selecionados == false">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>

                <rkm-button
                    v-if="selecionados == true"
                    @click="handleEntregue()"
                    color="success"
                    class="mb-2"
                >
                    Atribuir selecionado(s) como entregue
                </rkm-button>

                <rkm-button
                    v-if="selecionados == true"
                    @click="handleExamesPrint()"
                    color="secondary"
                    class="mb-2"
                >
                    Imprimir exame(s) selecionado(s)
                </rkm-button>

                <rkm-button
                    v-if="selecionados == true"
                    @click="handleListPrint()"
                    color="info"
                    class="mb-2"
                >
                    Imprimir listagem selecionada
                </rkm-button>

            </rkm-col>
        </rkm-row>

        <rkm-table
            v-if="itemsNotSave"
            :items="itemsNotSave || items"
            :fields="fields"
            hide-filters
            sort-by="pacienteNome"
        >

            <template v-slot:cell(checkbox)="{ item }">
                <rkm-form-checkbox
                    v-model="item.selecionado"
                    @change="handleBlur"
                />
            </template>

            <template v-slot:cell(pacienteNome)="{ item }">
                {{ item.pacienteNome }}

                <template v-if="item.pacienteNomeSocial">
                    <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{ item.pacienteNomeSocial }})</strong>
                    </template>

                    <template v-else>
                        ({{ item.pacienteNomeSocial }})
                    </template>
                </template>
            </template>

            <template v-slot:cell(usuarioId)="{ item }">
                <rkm-form-select
                    :label="false"
                    :options="usuario"
                    textField="usuarioOcupacao"
                    v-model="item.usuarioId"
                    valueField="id"
                    show-default-option
                    class="pt-0 mb-0"
                    @change="handleOcupacao(item)"
                />
            </template>

            <template v-slot:cell(entregue)="{ item }">
                <rkm-form-select
                    :label="false"
                    :options="data.form.entregue"
                    v-model="item.entregue"
                    class="pt-0 mb-0"
                />
            </template>

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    small
                    title="Imprimir exame"
                    @click="handlePrint(item)"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase, printExameLaboratorial } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        fields() {
            const fields = [
                {
                    key: 'checkbox',
                    label: '#',
                    class: 'col-min text-center',
                },
                {
                    key: "agendamentoNumero",
                    label: "Agendamento",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "data",
                    label: "Data do agendamento",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "dataColeta",
                    label: "Data da coleta",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "pacienteNome",
                    label: "Nome",
                    sortable: true
                },
                {
                    key: "dataNascimento",
                    label: "Data de nascimento",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "pacienteProntuario",
                    label: "Prontuário",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "nomeMedico",
                    label: "Médico solicitante",
                    sortable: true
                },
                {
                    key: "exameGrupoNome",
                    label: "Exame",
                    sortable: true
                },
                {
                    key: "impressao",
                    label: "Impressão",
                    sortable: true
                },
                {
                    key: "entregue",
                    label: "Entregue",
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                }
            ]

            return fields
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
    },
    created() {

        this.repositories = {
            entrega: this.getConectaSusRepository('exameLaboratorial.entregaExame'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                dataNascimento: null,
                prontuario: null,
                pacienteId: null,
                exameId: null,
                exames: null,
                grupos: null,
                agendamentoNumero: null,
                selecionados: true,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            selecionados: false,
            agendamentoExame: [],
            itemsNotSave: null,
            saveAgendamento: {
                agendamentos: [],
            },
            paciente: null,
            localPaciente: {
                autocompleteFieldsPaciente: {
                    paciente: [
                        { key: 'cidadao.nome', searchable: true },
                    ],
                },
            },
            enums: {
                statusAgendamento,
                preferenciaNome
            },
            unwatchers: {
                modelPeriodoEnd: null,
                modelPeriodoStart: null,
            },
        }
    },
    mixins: [repository, error, object, formats, data, printExameLaboratorial, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo = this.data.form.periodo

            this.$nextTick()
                .then(() => this.loadFields())
                .then(() => this.addWatchers())
        },
        save(){

            this.setLoading()

            this.repositories.entrega.store(this.prepareData())
                .then(() => {

                    this.showSaveNotification()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading(this.$nextTick(() => this.resetForm())))
        },
        prepareData() {

            if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                this.saveAgendamento.agendamentos = this.clone(this.itemsNotSave)

                const notSave = this.saveAgendamento

                return this.camelObjectKeysToSnakeRecursive(notSave)
            } else {

                const model = this.clone(this.data.model)

                return this.camelObjectKeysToSnakeRecursive(model)
            }
        },
        search() {

            this.setLoading()

            this.repositories.entrega.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos
                    this.selecionados = false
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            if (this.paciente) {

                params.pacienteId = this.paciente.id
                params.pacienteNome = this.paciente.cidadao.nome
            }

            if (this.model.dataNascimento) {

                params.dataNascimento = moment(this.model.dataNascimento).format('YYYY-MM-DD')
            }

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        handleSelecionados() {

            if (this.itemsNotSave) {

                const exameSelecionado = []
                const grupoSelecionado = []

                this.model.exames = null
                this.model.grupos = null

                this.itemsNotSave.filter(item => item.selecionado).map(exame => {

                    if (!exameSelecionado.find(u => u.id === exame.exameId
                        &&  u.agendamentoId === exame.agendamentoId)) {

                            exameSelecionado.push({
                                id: exame.exameId,
                                agendamentoId: exame.agendamentoId,
                            })
                    }
                })

                this.itemsNotSave.filter(item => item.selecionado && item.mapaAgrupado).map(exame => {

                    if (!grupoSelecionado.find(u => u.id === exame.exameGrupoId
                        && u.assinaturaProfissionalId === exame.assinaturaProfissionalId
                        && u.agendamentoId === exame.agendamentoId)) {

                            grupoSelecionado.push({

                                id: exame.exameGrupoId,
                                agendamentoId: exame.agendamentoId,
                                assinaturaProfissionalId: exame.assinaturaProfissionalId,
                            })
                    }
                })

                this.model.exames = exameSelecionado
                this.model.grupos = grupoSelecionado
            }
        },
        resetForm() {

            this.paciente = null
            this.model.dataNascimento = null
            this.model.agendamentoNumero = null
            this.model.prontuario = null
            this.model.exameId = null
            this.model.exames = null
            this.itemsNotSave = null
            this.selecionados = false

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        handleListPrint() {

            this.setLoading()

            this.handleSelecionados()

            this.repositories.impressao.entregaExameList(this.getSearchParams())
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
        },
        setListagem() {

            this.itemsNotSave = null
        },
        handlePrint(item) {

            this.setLoading()

            this.repositories.impressao.entregaExame({
                agendamento_id: item.agendamentoId,
                pertence_grupo: item.pertenceGrupo,
                exame_grupo_id: item.exameGrupoId,
                mapa_agrupado: item.mapaAgrupado ?? null,
                assinatura_profissional_id: item.assinaturaProfissionalId ?? null,
            })
            .then(response => {

                const content = new Blob([response.data], {type: response.headers['content-type']})
                const url = URL.createObjectURL(content)
                const link = document.createElement('a')

                link.href = url
                link.target = '_blank'
                link.click()
                link.remove()
            })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExamesPrint() {

            this.setLoading()

            this.handleSelecionados()

            this.repositories.impressao.entregaExameSelecionado(this.getSearchParams())
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
        },
        loadFields() {

            this.setLoading()

            this.repositories.entrega.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadExame(data.model.agendamentos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadExame(agendamento) {

            const exameCadastrado = []

            agendamento.map(exame => {

                const exameInserido = exameCadastrado.find(u => u.id
                    === exame.exameGrupoId)

                if (!exameInserido) {

                    exameCadastrado.push({

                        id: exame.exameGrupoId,
                        nome: exame.exameGrupoNome,
                    })
                }
            })

            if (exameCadastrado) {

                exameCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.agendamentoExame = exameCadastrado
        },
        handleEntregue() {

            this.showConfirmation(
                'Os exames selecionados serão atribuídos como ENTREGUE. Deseja continuar?',
                async () => this.itemsNotSave.forEach(item => {

                    if (item.selecionado == true) {

                        item.entregue = 1
                    }
                })
            )
        },
        selecionarTodos(){

            if(this.selecionados == true){

                this.selecionados = false
            } else {

                this.selecionados = true
            }

            this.itemsNotSave.forEach(element => {

                if(this.selecionados == true){

                    element.selecionado = true

                } else {

                    element.selecionado = false
                }
            })
        },
        handleBlur(){

            let selecionado = false

            this.itemsNotSave.map(element => {

                if (element.selecionado == true) {

                    selecionado = true
                }
            })

            if (selecionado) {

                this.selecionados = true
            } else {

                this.selecionados = false
            }
        },
        addWatchers() {

            this.addModelPeridoStartWatcher()
            this.addModelPeridoEndWatcher()
        },
        addModelPeridoStartWatcher() {

            this.unwatchers.modelPeriodoStart = this.$watch('model.periodo.start', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields()
                }

            })
        },
        addModelPeridoEndWatcher() {

            this.unwatchers.modelPeriodoEnd = this.$watch('model.periodo.end', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields()
                }

            })
        },
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}
</style>